module.exports = __webpack_public_path__ + "img/elementos-direita.45906fa5.svg";